import { CallCenterEndCallIcon, CallCenterListIcon2, CallerIcon, OngoingCallIcon, RecordUnfilledIcon, WaitingIcon } from "assets";
import { Typography } from "../../../../components/common";
import { Tooltip } from "antd";
import CallTimer from "../../LiveCalls/CallTimer";
import colors from '../../../../styles/colors.module.scss';
import './callCenterCallItemCard.scss';
import { Utils } from "utils";

type CallCenterCallItemCardProps = {
  phoneNumber: string;
  userName: string;
  agentExtension?: string;
  agentExtensions?: string[];
  departmentName: string;
  duration?: string;
  joinedEpoch?: string;
  serialNo?: string;
  onEndCall?: () => void;
  isQueued?: boolean;
  onClick?: () => void;
};

const departmentColors: Record<string, string> = {
  "120 Test Queue": colors.primaryText,
  "Tech_Support": colors.secondaryText,
  "Test_Queue": colors.ternaryText,
};

const CallCenterCallItemCard = ({
  phoneNumber,
  userName,
  agentExtension,
  agentExtensions = [],
  departmentName,
  duration = '',
  serialNo,
  onEndCall,
  isQueued = false,
  onClick,
  joinedEpoch
}: CallCenterCallItemCardProps) => {

const color = Utils.generateNameSpaceColor(departmentName)

  return (
    <li className="active-calls-list-item" onClick={onClick}>
      <div className="phone-icons-container">
        <div className="phone-recording-icon">
          {isQueued ? (
            <Typography variant="small-text-1">{serialNo}</Typography>
          ) : (
            <img src={RecordUnfilledIcon} alt="record-icon" />
          )}
        </div>
        <div className={`active-call-icon ${isQueued ? 'orange-icon' : ''}`}>
          <img src={isQueued ? WaitingIcon : OngoingCallIcon} alt="icon" />
        </div>
      </div>
      <div className="user-icon-container">
        <img src={CallCenterListIcon2} alt="icon" />
      </div>
      <div className="call-information-container">
        <div className="name-phone-container">
          <Typography variant="subHeading-1" className="user-name">
            <Tooltip title={userName}>
              {userName}
            </Tooltip>
            </Typography>
          <Typography variant="small-text-3" className="phone-number">
            <Tooltip title={phoneNumber}>
              {phoneNumber}
            </Tooltip>
          </Typography>
        </div>
        <div className="agency-department-container">
          {isQueued && agentExtensions?.length > 0 && (
            <div className="agency-quantity-container">
              <img src={CallerIcon} alt="caller-icon" />
              <Tooltip
                title={
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                    {agentExtensions.map((ext, idx) => (
                      <span key={ext + idx} style={{ display: "inline-block", margin: "2px", padding: "2px 8px", background: "#e6f7ff", color: "#1890ff", borderRadius: "8px", fontSize: "12px", fontWeight: 500, border: "1px solid #91d5ff" }}>
                        {ext}
                      </span>
                    ))}
                  </div>
                }
                placement="top"
              >
                <span style={{ cursor: "pointer", display: "inline-block" }}>
                  <Typography variant="small-text-3" className="agents-quantity">
                    {agentExtensions.join(', ')}
                  </Typography>
                </span>
              </Tooltip>
            </div>
          )}

          {!isQueued && agentExtension && (
            <div className="agency-quantity-container">
              <img src={CallerIcon} alt="caller-icon" />
              <Typography variant="small-text-3" className="agents-quantity">
                {agentExtension}
              </Typography>
            </div>
          )}


          <div className="department-name-container">
            <i className="bx bx-group" />
            <Typography
              variant="small-text-3"
              style={{ color: color || 'inherit' }}
            >
              <Tooltip title={departmentName}>
                {departmentName}
              </Tooltip>
            </Typography>
          </div>
        </div>
      </div>
      <div className="endButton-container">
        <div className="time-container">
          <CallTimer startTime={joinedEpoch ? new Date(Number(joinedEpoch) * 1000).toISOString() : undefined} variant="small-heading-1" />
        </div>
        <button type="button" className="endIcon-container" onClick={onEndCall}>
          <img src={CallCenterEndCallIcon} alt="call-center-end-call-icon" />
        </button>
      </div>
    </li>
  );
};

export default CallCenterCallItemCard;
